module.exports = __webpack_public_path__ + "static/media/CreacionEmpleado.16269e67.png";